@if (!user) {
  <patron-form [formGroup]="registerForm" (onSubmit)="onSubmit()">
    <div class="company-data mb-4">
      <div class="text-center border-bottom-2 border-primary-800 mb-3 text-primary-800">
        <h5>Cadastrar empresa</h5>
      </div>
      <patron-form-field
        [formGroup]="registerForm"
        formControlName="cnpj"
        label="CNPJ"
        type="mask"
        mask="00.000.000/0000-00">
      </patron-form-field>
    </div>
    <div class="user-data">
      <div class="text-center border-bottom-2 border-primary-800 mb-3 text-primary-800">
        <h5>Dados do usuário</h5>
      </div>
      <patron-form-field
        [formGroup]="registerForm"
        formControlName="name"
        label="Nome"></patron-form-field>
      <patron-form-field
        [formGroup]="registerForm"
        formControlName="email"
        label="E-mail"></patron-form-field>
      <patron-form-field
        [formGroup]="registerForm"
        formControlName="password"
        label="Senha"
        type="password">
      </patron-form-field>
      <patron-form-field
        [formGroup]="registerForm"
        formControlName="password_confirmation"
        label="Repita a senha"
        type="password">
      </patron-form-field>
    </div>
    <patron-button
      type="submit"
      [loading]="loading"
      customStyle="width: 100%"
      customClass="flex justify-content-center"
      class="w-full"
      iconName="bi-box-arrow-in-right"
      [disabled]="!isPraxis">
      Cadastrar
    </patron-button>
    <div class="mt-3">
      <patron-button
        routerLink="/auth"
        variant="outline"
        color="secondary"
        iconName="bi-box-arrow-left">
        Já tenho cadastro
      </patron-button>
    </div>
  </patron-form>
}

@if (user) {
  <div>
    <h6 class="mb-3">
      <patron-icon name="bi-person-raised-hand"></patron-icon>
      <span class="ms-2"> Quase tudo pronto {{ user.name }}! </span>
    </h6>
    <patron-alert>
      <p class="mb-0 font-italic">
        Para acessar o sistema e garantir a sua segurança, precisamos que confirme o seu email,
        clicando no link que enviamos para <strong>{{ user.email }}</strong>
      </p>
    </patron-alert>
  </div>
}

<div hidden>
  <patron-auth></patron-auth>
</div>
